import { HttpRequest } from "../utils"

const httpRequest = new HttpRequest()

export interface IExternalParty {
  id: string
  name: string
  type: string
  isActive: boolean
  contactPhone: string | null
  city: string | null
  createdAt?: string
  updatedAt?: string
}

export interface IExternalPartyListResponse {
  rows: IExternalParty[]
  count: number
}

export const list = async (data: {
  filter?: { search?: string; isActive?: boolean; type?: string }
  offset?: { limit: number; skip: number }
  order?: Array<[string, string]>
}): Promise<IExternalPartyListResponse> => {
  return httpRequest.post("/ord/external-party/list", data as any)
}

export const get = async (id: string): Promise<IExternalParty> => {
  return httpRequest.get(`/ord/external-party/${id}`)
}
